import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import PaymentStatusCard from "./PaymentStatusCard";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AlertMessage from "./AlertMessage";
import { useSelector } from "react-redux";
import {
  formatIndianNumber,
} from "../common-functions/PaymentCommonFunctions";
import { useFormik } from "formik";
import TextFieldInput from "../../../../components/TextFieldInput";
import { useDispatch } from "react-redux";
import {
  createRazorpayOrder,
  verifyVoucherPayment,
  getVoucherById,
} from "../../voucher-form.slice";
import { useParams } from "react-router-dom";
import { useRazorpayPayment } from "../../components/payments/useRazorpayPayment";
import greenTriangle from "../../../../assets/icons/green-triangle.svg"
import blueTriangle from "../../../../assets/icons/blue-triangle.svg"
import yellowTriangle from "../../../../assets/icons/yellow-triangle.svg"
import SummaryHeader from "./SummaryHeader";
import {  EOIFormStatus, EOIPaymentStatus, FORM_PHASE, GATEWAY,getFrontEndStatus } from "../../../../config/constant";
import * as Yup from "yup";
import { useEasebuzzPayment } from "../payments/useEasebuzzPayment";
import PaymentFailedModal from "../../../new-booking-form/Individual-components/PaymentFailedModal";

const RelandingPaymentStatus = () => {
  const [paymentAmount, setPaymentAmount] = useState("");
  const { applicantData } = useSelector((state) => state.voucherForm);
  const { voucherId } = useParams();

  const dispatch = useDispatch();
  const {
    initiatePayment,
    paymentResponse,
  } = useRazorpayPayment();
  const paymentStatusformik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please enter amount in field to Pay")
    })
  });
  const { initiateEasebuzzPayment,loading, paymentResponse:easebuzzPaymentResponse } = useEasebuzzPayment()
  const [openPaymentFailedModal,setOpenPaymentFailedModal] = useState(false)
  const [failedAmount,setFailedAmount]= useState('')

  // eslint-disable-next-line no-unused-vars
  const [verifying, setVerifying] = useState(false);


  const handleEasebuzzPay = async (amount) => {
        await paymentStatusformik.validateForm();
        paymentStatusformik.setTouched({ amount: true });
        if(!amount) return
      try {
        const orderRes = await dispatch(
          createRazorpayOrder({
            amount,
            entityType: "voucher",
            entityId:applicantData?.id?.toString(),
            projectId:applicantData?.campaignId,
            gateway: GATEWAY?.EASEBUZZ,
           
            redirectUrl: window.location.href,
             notes: {
            productInfo:  applicantData?.uniqueReferenceId,
            voucherId: voucherId,
            voucherAmount: Number(PaymentObject?.amountPayable),
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
          })
        ).unwrap();
  
        const orderAccessKey = orderRes.accessKey;
  
        if (!orderAccessKey) {
          throw new Error(
            "Backend did not return access_key. Check createRazorpayOrder response: " +
              JSON.stringify(orderRes)
          );
        }
  
        await initiateEasebuzzPayment({
          orderAccessKey,
          easebuzzKey:orderRes?.easebuzzKey
        });

      } catch (err) {
        setFailedAmount(amount);
        setOpenPaymentFailedModal(true);
        console.error("Failed to initiate payment:", err);
      }

    };


  const handleRazorPay = async (amount) => {
    await paymentStatusformik.validateForm();
    paymentStatusformik.setTouched({ amount: true });

    try {
      // 1. Create order
      const orderRes = await dispatch(
        createRazorpayOrder({
          amount: amount,
          entityType: "voucher",
          entityId: applicantData?.id?.toString(),
          projectId:applicantData?.campaignId,
          gateway: GATEWAY?.RAZORPAY,
          notes: {
            voucherId: voucherId,
            voucherAmount: Number(PaymentObject?.amountPayable),
            productInfo: applicantData?.uniqueReferenceId,
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
        })
      ).unwrap();
      // 2. Open Razorpay popup
      initiatePayment({
        amount: orderRes?.razorpayOrder?.amount,
        currency: orderRes?.razorpayOrder?.currency,
        orderId: orderRes?.razorpayOrder?.id,
        name: "Puravankara",
        description: "Payment",

        prefill: {
          name: orderRes?.razorpayOrder?.notes?.guest?.name,
          email: orderRes?.razorpayOrder?.notes?.guest?.email,
          contact: orderRes?.razorpayOrder?.notes?.guest?.phone,
        },
        razorpayKey: orderRes?.razorpayKey,
      });
    } catch (err) {
      console.error("Payment failed:", err);
    }
  };
  function extractPaymentDetails(data) {
    // Fallback to 0 if not provided
    const amountPayable = Number(data?.amountPayable) || 0;

    // Prefer `totalAmountPaid` if exists, else sum from transactions
    let amountPaid = Number(data?.totalAmountPaid) || 0;

    if (!amountPaid && Array.isArray(data?.transactions)) {
      amountPaid = data.transactions.reduce((sum, txn) => {
        const paid = Number(txn?.paidAmount) || 0;
        return sum + paid;
      }, 0);
    }

    // Ensure non-negative due
    let amountDue = amountPayable - amountPaid;
    if (amountDue < 0) amountDue = 0;

    return {
      amountPayable,
      amountPaid,
      amountDue,
    };
  }

  const PaymentObject = extractPaymentDetails(applicantData?.paymentDetails);

  useEffect(() => {
    if (!paymentResponse) return;

    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: paymentResponse?.razorpay_order_id,
          paymentId: paymentResponse?.razorpay_payment_id,
          signature: paymentResponse?.razorpay_signature,
          gateway: GATEWAY?.RAZORPAY,
          clientResponse:JSON.stringify(paymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        dispatch(getVoucherById(`/${voucherId}`));
        setPaymentAmount("");
        paymentStatusformik?.resetForm();
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
      }
    };

    verifyPayment();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentResponse]);

  useEffect(() => {
    if (!easebuzzPaymentResponse) return;

    if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "failure") {
      setFailedAmount(easebuzzPaymentResponse?.amount)
      setOpenPaymentFailedModal(true)
      return;
    }
    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: easebuzzPaymentResponse?.txnid,
          paymentId: easebuzzPaymentResponse?.easepayid,
          signature: easebuzzPaymentResponse?.hash,
          gateway: GATEWAY?.EASEBUZZ,
          clientResponse:JSON.stringify(easebuzzPaymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        dispatch(getVoucherById(`/${voucherId}`));
        setPaymentAmount("");
        paymentStatusformik?.resetForm();
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
      }
    };
    if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "success") {
      verifyPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [easebuzzPaymentResponse]);

  const handleProceedGateway = (selectedGateway) => {
    if (selectedGateway === GATEWAY?.RAZORPAY) {
      //setIsPayViaEasebuzz(false)
      handleRazorPay(failedAmount)
      setFailedAmount('')
    }
    if (selectedGateway === GATEWAY?.EASEBUZZ) {
      //setIsPayViaEasebuzz(true)
      handleEasebuzzPay(failedAmount)
      setFailedAmount('')
    }
    setOpenPaymentFailedModal(false)
  }
  return (
    <Box>
    <SummaryHeader applicantData={applicantData} fromRelanding={true} />
     {applicantData?.queueId &&
      (
          <Box mb={2} mt={2}>
            <AlertMessage
              type="info"
              title="Customers are required to present their Queue ID when invited to the launch event to select and finalize their preferred unit."
            />
          </Box>
        )}
      <Typography
        sx={{ fontSize: "14px", fontWeight: 600, px: "12px" }}
        mt={2.5}
        mb={1}
      >
        Payment Status
      </Typography>

      {applicantData?.voucherFormStatus !== EOIFormStatus.CANCEL_ACCEPTED &&
        applicantData?.paymentStatus === EOIPaymentStatus.PARTIALLY_PAID && !applicantData?.queueId && (
          <Box mb={2}>
            <AlertMessage
              type="warning"
              title="Final Queue ID Assignment Pending"
              message={`Final Queue ID will be assigned once the complete amount of ₹${formatIndianNumber(
                PaymentObject?.amountPayable
              )} is received.`}
              highlight={`${formatIndianNumber(
                PaymentObject?.amountPayable
              )} is received`}
            />
          </Box>
        )}
      {(applicantData?.voucherFormStatus === EOIFormStatus.CANCEL_ACCEPTED || 
      applicantData?.voucherFormStatus === EOIFormStatus.REFUND_INITIATED )&& (
        <Box mb={2}>
          <AlertMessage
            type="error"
            title={getFrontEndStatus(applicantData?.voucherFormStatus)}
            message=""
          />
        </Box>
      )}
     {(applicantData?.voucherFormStatus === EOIFormStatus.CANCELLED  )&& (
        <Box mb={2}>
          <AlertMessage
            type="error"
            title={getFrontEndStatus(applicantData?.voucherFormStatus)}
            message=""
          />
        </Box>
      )}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={6} md={4}>
          <PaymentStatusCard
            img={blueTriangle}
            amount={formatIndianNumber(PaymentObject?.amountPayable)}
            title={applicantData?.formPhase  === FORM_PHASE.VOUCHER ?"Voucher Amount" :"EOI Amount"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PaymentStatusCard
            img={greenTriangle}
            amount={formatIndianNumber(PaymentObject?.amountPaid)}
            title="Amount Paid"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PaymentStatusCard
            img={yellowTriangle}
            amount={formatIndianNumber(PaymentObject?.amountDue || 0)}
            title="Balance Due"
          />
        </Grid>
      </Grid>

      <Typography
        sx={{ fontSize: "14px", fontWeight: 600 }} mb={1}
      >
        Amount
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "24px",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ maxWidth: "366px" }}>
          <TextFieldInput
            field={{
              placeholder: "Enter Amount",
              name: "amount",
              required: false,
              handleOnChange: (e) => {
                const value = e.target.value;
                const numericValue = value?.replace(/[^0-9]/g, "");
                paymentStatusformik.setFieldValue("amount", numericValue);
                setPaymentAmount(value);
              },
              readonly: false,
            }}
            formik={paymentStatusformik}
          />
        </Box>

        <Button
          variant="contained"
          endIcon={<ChevronRightIcon />}
          onClick={() => handleEasebuzzPay(paymentAmount)}
          sx={{
            backgroundColor: "#1A407D",
            textTransform: "none",
            fontSize: "14px",
            px: 3,
            py: 1.2,
            borderRadius: "8px",
            fontWeight: 400,
            "&:hover": {
              backgroundColor: "#1A407D",
            },
          }}
          disabled={loading}
        >
          Pay Now
        </Button>
      </Box>
      <PaymentFailedModal open={openPaymentFailedModal} onClose={() => { setOpenPaymentFailedModal(false) }} onProceed={(selectedGateway) => { handleProceedGateway(selectedGateway) }} />
    </Box>
  );
};

export default RelandingPaymentStatus;